// import "../../../Styles/tab.component.css";

import { Paper, Tabs } from "@mantine/core";
import { useEffect, useState } from "react";
import CreateView from "./createView";
import EditViewNew from "./editViewNew";
import AttributeCategoryManagerNew from "./AttributeCategoryManagerNew";
import Repository from "../../_base/helper/HttpHelper";
import { API_ROUTE } from "../../const/apiRoute";
import { MessageResponse } from "../../model/MessageResponse";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";
import AttributeFormStore from "../../store/AttributeFormStore";

const MainView = ({
  handleDeleteViewClose,
  handleDeleteViewCloseWithCallback,
  forceReloadData,
  deleteViewStatus,
  id,
}: any) => {
  const [activeTab, setActiveTab] = useState<string | null>("info1");
  const [componentKey, setComponentKey] = useState(0); // Key để force re-render
  const store = AttributeFormStore.getInstance();

  // Cleanup và reset store khi chuyển đổi giữa create/edit
  useEffect(() => {
    // Reset store khi chuyển sang CREATE mode (không có id)
    if (!id) {
      store.reset();
      setComponentKey((prev) => prev + 1); // Force re-render CreateView để đảm bảo reset hoàn toàn
    }
    // Nếu có id khác với data hiện tại trong store, cũng reset để tránh hiển thị data cũ
    else {
      const currentData = store.getAttributeData();
      if (currentData && currentData.id !== id) {
        store.reset();
        setComponentKey((prev) => prev + 1); // Chỉ force re-render EditView khi ID thay đổi
      }
    }

    return () => {
      // Cleanup khi component unmount
      if (!id) {
        store.reset();
      }
    };
  }, [id, store]); // Thêm store vào dependency

  // Hàm lưu chính thức
  const saveFinal = async () => {
    try {
      const finalAttributeData = store.getAttributeData();
      const finalCategoriesData = store.getSelectedCategories();

      if (!finalAttributeData) {
        NotificationExtension.Info(
          "Vui lòng nhập thông tin cơ bản ở tab 'Cơ bản' trước khi lưu!"
        );
        return;
      }

      // Validation
      if (
        !finalAttributeData.attributeName ||
        !finalAttributeData.attributeCode
      ) {
        NotificationExtension.Info(
          "Vui lòng điền đầy đủ thông tin cơ bản (Tên thuộc tính, Mã thuộc tính)!"
        );
        return;
      }

      // Chuẩn bị dữ liệu - lấy attribute values từ store
      const attributeValues =
        finalAttributeData.listTblAttributeValueCommand || [];

      const dataToSubmit = {
        ...finalAttributeData,
        listTblAttributeValueCommand: attributeValues,
        listTblCategoryAttributeModels: finalCategoriesData,
      };

      // Gọi API
      const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
      const apiUrl = id
        ? API_ROUTE.MODIFY_ATTRIBUTE
        : API_ROUTE.CREATE_ATTRIBUTE;
      const response = await repository.post<MessageResponse<boolean>>(
        apiUrl,
        dataToSubmit
      );

      if (response && response.success) {
        store.reset(); // Reset store sau khi thành công
        NotificationExtension.Success(
          id ? "Cập nhật thuộc tính thành công!" : "Tạo thuộc tính thành công!"
        );

        if (forceReloadData) {
          forceReloadData();
        } else {
          handleDeleteViewClose(deleteViewStatus + 1);
        }

        setTimeout(() => {
          modals.closeAll();
        }, 500);
      } else {
        NotificationExtension.Fails(
          id ? "Cập nhật thuộc tính thất bại!" : "Tạo thuộc tính thất bại!"
        );
      }
    } catch (error) {
      console.error("Error saving attribute:", error);
      NotificationExtension.Fails("Có lỗi xảy ra khi lưu thuộc tính!");
    }
  };

  return (
    <>
      <Paper shadow="md" radius="lg">
        <Tabs p={"xs"} value={activeTab} onChange={setActiveTab}>
          <Tabs.List>
            <Tabs.Tab value="info1">Cơ bản</Tabs.Tab>
            <Tabs.Tab value="info3">Danh mục</Tabs.Tab>
          </Tabs.List>

          {/* ✅ Sử dụng key để force re-render khi cần thiết */}
          {activeTab === "info1" && (
            <Tabs.Panel value="info1">
              {id ? (
                <EditViewNew
                  key={`edit-${id}-${componentKey}`}
                  id={id}
                  onSaveFinal={saveFinal}
                  store={store}
                />
              ) : (
                <CreateView
                  key={`create-${componentKey}`}
                  onSaveFinal={saveFinal}
                  store={store}
                />
              )}
            </Tabs.Panel>
          )}

          {activeTab === "info3" && (
            <Tabs.Panel value="info3">
              <AttributeCategoryManagerNew
                key={id ? `category-edit-${id}` : `category-create`}
                attributeId={id}
                onSaveFinal={saveFinal}
                store={store}
              />
            </Tabs.Panel>
          )}
        </Tabs>
      </Paper>
    </>
  );
};

export default MainView;
